class DrawerMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this;
    this.mainLevel = this.el.querySelector('.drawer-menu__contents');
    this.init();
  }

  init() {
    // These toggle submenu panel
    this.firstLevelItemsWithChildren = this.el.querySelectorAll('.drawer-menu__item-input');
    this.firstLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

    // These handle closing of navigation
    this.closeButtons = this.el.querySelectorAll('[data-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeAllItems.bind(this));
    });

    this.closeFullDrawer = document.querySelectorAll('[data-menu-drawer-close]');
    this.closeFullDrawer.forEach((btn) => {
      btn.addEventListener('click', function() {
        document.querySelector('drawer-menu').querySelector('[data-drawer-close]').click();
      });
    });

    this.overlay = this.el.querySelector('[data-drawer-overlay]');
    this.overlay.addEventListener('click', this.closeAllItems.bind(this));

    // These handle going back to previous panel
    this.secondLevelBackButtons = this.el.querySelectorAll('[data-drawer-submenu-close]');
    this.secondLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });

    // Handle opening of specific subitem from anywhere in the theme
    this.subitemOpeners = document.querySelectorAll('[data-drawer-submenu-open]');
    this.subitemOpeners.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    });

    // Handle showing panel images on hover
    this.submenuItems = document.querySelectorAll('.drawer-submenu__item');
    this.submenuItems.forEach((button) => {
      button.addEventListener('mouseover', this.handleSubmenuHover.bind(this));
      button.addEventListener('mouseout', this.handleSubmenuHover.bind(this));
    });
  }

  closeAllItems(event, skipEl) {
    const checkboxes = this.mainLevel.querySelectorAll('input:checked');

    checkboxes.forEach((checkbox) => {
      if (skipEl && checkbox === skipEl) {
        return;
      }

      const accordion = checkbox.closest('[data-accordion-item]');

      if (accordion) {
        if (screen.width <= 1000) {
          const parent = accordion.closest('.drawer-menu__contents');
          parent.classList.remove('pull-left');
        }

        accordion.classList.remove('is-open');
      }

      setTimeout(() => {
        checkbox.checked = false;
      }, 200);
    });

    if (!skipEl) {
      this.mainLevel.classList.remove('has-open-submenu');

      this.subitemOpeners.forEach((button) => {
        button.classList.remove('active');
      });
    }
  }

  toggleMenuItem(scope) {
    const input = scope.currentTarget || scope;
    if (!input) return;

    this.closeAllItems(scope, input);

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) {
      return;
    }
    if (screen.width <= 1000) {
      const parent = accordion.closest('.drawer-menu__contents');
      parent.classList.toggle('pull-left');
      this.mainLevel.classList.add('has-open-submenu');
    }
    
    accordion.classList.toggle('is-open');
    if (accordion.classList.contains('is-open') && screen.width > 1000) {
      /*
      * Add extra class on subitem panel to prevent slide out animation when switching between subitem panels.
      */
      const accordionSubitemPanel = accordion.querySelector('[data-accordion-panel]');
      const onTransitionEnd = () => {
        this.mainLevel.classList.add('has-open-submenu');
        accordionSubitemPanel.removeEventListener('transitionend', onTransitionEnd)
      }
      accordionSubitemPanel.addEventListener('transitionend', onTransitionEnd.bind(this));
    }
  }

  toggleMenuItemFromTheme(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');

    for (const input of this.firstLevelItemsWithChildren) {
      if (input.getAttribute('data-href') === url) {
        target = input;
        break;
      }
    }

    if (!target) return;

    Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'));

    this.subitemOpeners.forEach((button) => {
      button.classList.remove('active');
    });

    button.classList.add('active');

    const evt = new Event('change');
    target.checked = true;
    target.dispatchEvent(evt);
  }

  toggleSubPanel(event) {
    this.closeAllItems();

    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-submenu-close');
    if (!targetSelector) {
      return;
    }

    const input = document.getElementById(targetSelector);
    if (!input) {
      return;
    }

    input.focus();
  }

  handleSubmenuHover(event) {
    const item = event.currentTarget;
    
    event.currentTarget.closest('.drawer-submenu__panel-container').querySelectorAll('.drawer-submenu__panel-img').forEach((element) => {
      element.classList.remove('visible');
    });

    const targetSelector = document.querySelector(`.drawer-submenu__panel-img[data-hover-handle="${item.getAttribute('data-hover-handle')}`);
    
    if (!targetSelector) {
      event.currentTarget.closest('.drawer-submenu__panel-container').querySelector('.drawer-submenu__panel-img.main')?.classList.add('visible');

      return;
    }

    if (event.type === 'mouseover') {
      targetSelector.classList.add('visible');
    } else {
      event.currentTarget.closest('.drawer-submenu__panel-container').querySelector('.drawer-submenu__panel-img.main')?.classList.add('visible');
    }
  }
}

if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}
